import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="bg-navy text-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <img src="/remax-general.png" alt="RE/MAX" className="h-8 w-auto" />
        <p className="font-heading text-2xl mt-6 font-light">
          Mike Sidhu
        </p>
        <p className="font-mono text-[0.65rem] uppercase tracking-[0.18em] text-brass mt-2">Personal Real Estate Corporation</p>
        <p className="font-mono text-[0.65rem] uppercase tracking-[0.18em] text-white/50 mt-1">RE/MAX Performance Realty</p>
        <p className="font-body text-white/70 mt-3 max-w-md leading-relaxed">
          British Columbia's trusted authority in foreclosure and court-ordered real estate sales.
          Licensed since 2009 with RE/MAX Performance Realty.
        </p>
      </div>

      <div>
        <p className="overline mb-5">Navigate</p>
        <ul className="space-y-3 font-body text-white/80 text-sm">
          <li><Link to="/listings" className="hover:text-brass transition-colors">Featured Listings</Link></li>
          <li><Link to="/office-listings" className="hover:text-brass transition-colors">Office Listings</Link></li>
          <li><Link to="/about" className="hover:text-brass transition-colors">About Mike</Link></li>
          <li><Link to="/process" className="hover:text-brass transition-colors">The Process</Link></li>
        </ul>
      </div>

      <div>
        <p className="overline mb-5">Contact</p>
        <ul className="space-y-3 font-body text-white/80 text-sm">
          <li className="flex items-center gap-2"><Phone size={15} className="text-brass" /> 604-831-2500</li>
          <li className="flex items-center gap-2"><Mail size={15} className="text-brass" /> mike@mikesidhu.com</li>
          <li className="flex items-start gap-2"><MapPin size={15} className="text-brass mt-0.5" /> RE/MAX Performance Realty, Surrey, BC</li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[0.7rem] uppercase tracking-[0.15em] text-white/50">
          © {new Date().getFullYear()} Mike Sidhu, Personal Real Estate Corporation · Each office independently owned and operated
        </p>
        <p className="font-mono text-[0.7rem] uppercase tracking-[0.15em] text-white/50">
          Mortgage referrals via DLC · <Link to="/admin/login" className="hover:text-brass">Admin</Link>
        </p>
      </div>
    </div>
  </footer>
);
